export default "/images/bg-1.png?52c61ac08afe825ea1b279c47c89bce6";